'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useId, } from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { cx } from '../../../internal/cx.js';
import { CheckGlyph, DashGlyph } from '../../../internal/icons.js';
import { useFieldControl } from '../form-field/index.js';
/**
 * A checkbox with optional inline label. Supports `checked="indeterminate"`.
 * Space toggles it; it participates in native forms via `name`/`value`.
 */
export const Checkbox = forwardRef(function Checkbox({ label, description, invalid, className, ...rest }, ref) {
    const auto = useId();
    const props = useFieldControl(rest, { invalid });
    const id = props.id ?? `mn-checkbox-${auto}`;
    const descriptionId = description ? `${id}-description` : undefined;
    const describedBy = cx(props['aria-describedby'], descriptionId);
    const control = (_jsx(CheckboxPrimitive.Root, { ref: ref, ...props, id: id, "aria-describedby": describedBy, className: cx('mn-checkbox', label ? undefined : className), children: _jsx(CheckboxPrimitive.Indicator, { className: "mn-checkbox__indicator", children: props.checked === 'indeterminate' ? _jsx(DashGlyph, {}) : _jsx(CheckGlyph, {}) }) }));
    if (!label)
        return control;
    return (_jsxs("div", { className: cx('mn-choice', className), "data-disabled": props.disabled || undefined, children: [control, _jsxs("div", { className: "mn-choice__text", children: [_jsx("label", { htmlFor: id, className: "mn-choice__label", children: label }), description ? (_jsx("p", { id: descriptionId, className: "mn-choice__description", children: description })) : null] })] }));
});
//# sourceMappingURL=checkbox.js.map